import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// React Router keeps a history index in window.history.state.idx; idx 0 = first entry of this tab.
export const canGoBack = () => (window.history.state?.idx ?? 0) > 0;

// Pops the real history stack (preserves query strings / filters / tabs of the previous view).
// Falls back to `fallback` (replace) only when this tab has no previous entry, e.g. opened via direct link.
export function useBack(fallback = "/dashboard") {
  const nav = useNavigate();
  return () => (canGoBack() ? nav(-1) : nav(fallback, { replace: true }));
}

export default function BackButton({ fallback = "/dashboard", label = "Back", testid = "back-btn", className = "" }) {
  const back = useBack(fallback);
  return (
    <button type="button" data-testid={testid} onClick={back} title={canGoBack() ? "Go back" : `Go to ${fallback}`}
      className={`no-print inline-flex items-center gap-1.5 h-9 px-2.5 rounded-md text-xs font-semibold uppercase tracking-wider text-slate-600 hover:text-slate-900 hover:bg-slate-100 ${className}`}>
      <ArrowLeft size={16} /> <span className="hidden sm:inline">{label}</span>
    </button>
  );
}
